// 对与用户相关的操作进行封装

import request from "@/utils/request.js";

/**
 * 根据手机号查询卡
 * @param {*} phone 手机号

 */
const shopId = sessionStorage.getItem("shopInfo")
  ? JSON.parse(sessionStorage.getItem("shopInfo")).shopCode
  : "";

export const phoneSearch = params => {
  return request({
    method: "GET",
    url: "/api/mbrinfo/getStoredValueCard",
    headers: {
      "Content-Type": "application/json"
    },
    params: params
    // 参数: 根据接口文档，参数要通过body（请求体中）来传，对应到axios中，用data
  });
};

/**
 * 根据卡号查询卡
 * @param {*} card 储值卡

 */
export const cardSearch = params => {
  return request({
    method: "GET",
    // url: '/mbrinfo/getStoredValueCardByValueCard?valueCard=' + card + "&shopCode=" + shopI,
    url: "/api/mbrinfo/getStoredValueCardByValueCard",
    headers: {
      "Content-Type": "application/json"
    },
    params: params
  });
};

/**
 * 根据卡号查询卡
 * @param {*} cardNo 储值卡号

 */
export const getCardInfo = cardNo => {
  return request({
    method: "GET",
    url: "/api/mbrinfo/getStoredValueCardByValueCard",
    headers: {
      "Content-Type": "application/json"
    },
    params: {
      shopCode: shopId,
      valueCard: cardNo
    }
  });
};

export const findRechargeRules = () => {
  return request({
    method: "GET",
    url: "/api/ranchargerule/findByActiveType?activeType=1",
    headers: {
      "Content-Type": "application/json"
    }
  });
};

/**
 * 绑定储值卡
 * @param {*} cardInfo 储值卡
 */
export const bindValueCard = cardInfo => {
  return request({
    method: "POST",
    url: "/api/mbrinfo/bindValueCard",
    headers: {
      "Content-Type": "application/json"
    },
    params: cardInfo
  });
};

/**
 *  生成微信支付二维码
 * data ={
	"amount": 0,
	"clerkId": 0,
	"clerkOpenId": "",
	"createTime": "",
	"shopId": 0,
	"userId": "",
	"userMobile": "",
	"valueCardNo": ""
}
 * @param {*} data 储值卡
 */
export const getWeixinPayQrcode = data => {
  return request({
    method: "POST",
    url: "/api/wxpay/nativePay",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
};
/**
     *  生成支付宝支付二维码
     * data ={
    	"amount": 0,
    	"clerkId": 0,
    	"clerkOpenId": "",
    	"createTime": "",
    	"shopId": 0,
    	"userId": "",
    	"userMobile": "",
    	"valueCardNo": ""
    }
     * @param {*} data 储值卡
     */
export const getAliPayQrcode = data => {
  return request({
    method: "POST",
    url: "/api/alipay/pay",
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  });
};
/**
 *  查询微信支付结果
 * @param {*} orderNo 订单号
 */
export const getPayResult = orderNo => {
  return request({
    method: "POST",
    url: "/api/wxpay/query",
    headers: {
      "Content-Type": "application/json"
    },
    params: { out_trade_no: orderNo }
  });
};
